import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import ClearIcon from "@material-ui/icons/Clear";

import { getLogs, removeAbsentee } from "../../../../adminModel/lots";
import { useAlert } from "react-alert";

/* =========================================================
   TABLE CELL
========================================================= */

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontWeight: "bold",
  },

  body: {
    fontSize: 14,
  },
}))(TableCell);

/* =========================================================
   TABLE ROW
========================================================= */

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

/* =========================================================
   STYLES
========================================================= */

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

/* =========================================================
   COMPONENT
========================================================= */

export default function BidLogs({ eventId, something }) {
  const classes = useStyles();
  const alert = useAlert();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* =======================================================
     FETCH BID LOGS
  ======================================================= */

  useEffect(() => {
    if (!eventId || !something) {
      return;
    }

    const fetchData = async () => {
      setLoading(true);

      try {
        const results = await getLogs(
          something,
          eventId
        );

        if (
          results &&
          results.data &&
          results.data.bidlogs
        ) {
          setData(results.data.bidlogs);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error(
          "Failed to fetch bid logs:",
          error
        );

        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [eventId, something]);

  /* =======================================================
     REMOVE BID
  ======================================================= */

  const handleClickRemoveAbsentee = async (
    event,
    id
  ) => {
    const confirmed = window.confirm(
      "Are you sure you want to remove this bid?"
    );

    if (!confirmed) {
      return;
    }

    setLoading(true);

    const requestData = {
      absenteeId: id,
    };

    try {
      const result = await removeAbsentee(
        requestData
      );

      console.log(result);

      if (result && result.sucess === true) {
        alert.success(
          result.msg ||
            "Bid removed successfully."
        );

        // Remove row immediately
        setData((previousData) =>
          previousData.filter(
            (row) => row.id !== id
          )
        );
      } else {
        alert.error(
          result.msg ||
            "Failed to remove bid."
        );
      }
    } catch (error) {
      console.error(
        "Error removing bid:",
        error
      );

      alert.error(
        "An unexpected error occurred."
      );
    } finally {
      setLoading(false);
    }
  };

  /* =======================================================
     FORMAT DATE
  ======================================================= */

  const formatDate = (dateValue) => {
    if (!dateValue) {
      return "N/A";
    }

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return "N/A";
    }

    return date.toLocaleString();
  };

  /* =======================================================
     FORMAT HAMMER
  ======================================================= */

  const formatHammer = (amount) => {
    if (
      amount === null ||
      amount === undefined ||
      amount === ""
    ) {
      return "0";
    }

    const parsedAmount = Number(amount);

    if (Number.isNaN(parsedAmount)) {
      return amount;
    }

    return parsedAmount.toLocaleString();
  };

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-label="bid logs table"
        >
          {/* =================================================
              TABLE HEADER
          ================================================= */}

          <TableHead>
            <TableRow>
              <StyledTableCell align="center">
                Bid Date
              </StyledTableCell>

              <StyledTableCell>
                Username
              </StyledTableCell>

              <StyledTableCell align="center">
                Lot number
              </StyledTableCell>

              <StyledTableCell align="center">
                Bidder type
              </StyledTableCell>

              <StyledTableCell align="center">
                Hammer price
              </StyledTableCell>

              <StyledTableCell align="center">
                Status
              </StyledTableCell>

              <StyledTableCell align="center">
                Action
              </StyledTableCell>
            </TableRow>
          </TableHead>

          {/* =================================================
              TABLE BODY
          ================================================= */}

          <TableBody>
            {data.map((row) => (
              <StyledTableRow key={row.id}>
                {/* Bid Date */}

                <StyledTableCell align="center">
                  {formatDate(row.date_created)}
                </StyledTableCell>

                {/* Username */}

                <StyledTableCell
                  component="th"
                  scope="row"
                >
                  {row.email || "N/A"}
                </StyledTableCell>

                {/* Lot Number */}

                <StyledTableCell align="center">
                  <Typography
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {row.lot_number || "N/A"}
                  </Typography>
                </StyledTableCell>

                {/* Bidder Type */}

                <StyledTableCell align="center">
                  {row.bidder_type || "N/A"}
                </StyledTableCell>

                {/* Hammer Price */}

                <StyledTableCell align="center">
                  Php {formatHammer(row.hammer)}
                </StyledTableCell>

                {/* Status */}

                <StyledTableCell align="center">
                  {row.trans_status || "N/A"}
                </StyledTableCell>

                {/* Action */}

                <StyledTableCell align="center">
                  {row.trans_status === "POSTED" ? (
                    <ClearIcon
                      style={{
                        color: "red",
                        cursor: loading
                          ? "default"
                          : "pointer",
                      }}
                      onClick={(event) => {
                        if (!loading) {
                          handleClickRemoveAbsentee(
                            event,
                            row.id
                          );
                        }
                      }}
                    />
                  ) : null}
                </StyledTableCell>
              </StyledTableRow>
            ))}

            {/* =================================================
                LOADING
            ================================================= */}

            {loading && (
              <TableRow>
                <TableCell
                  colSpan={7}
                  align="center"
                >
                  <Typography
                    style={{
                      padding: 20,
                      color: "#777",
                    }}
                  >
                    Loading...
                  </Typography>
                </TableCell>
              </TableRow>
            )}

            {/* =================================================
                NO DATA
            ================================================= */}

            {!loading && data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={7}
                  align="center"
                >
                  <Typography
                    style={{
                      padding: 20,
                      color: "#777",
                    }}
                  >
                    No bid logs found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}